export const CollaborationOnline = {
  "Dlg": {
    "deleteShareFile": "The sharing of this document has expired, so you will not be able to view shared comments. If you have any questions, please contact the owner."
  }
}